import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import { Box, Tooltip } from "@mui/material";
import discountImg from "../../assets/vactor-images/discount.svg";
import { NavLink } from "react-router-dom";
import { titleToUrl } from "../../shared/extra";
import { defaultProductImage } from "../../imports/generalImport";
import { isDiscountedProduct } from "../../hooks/utilsFn/utilsFn"

const AllGiftCard = ({ singleProductData }) => {
    const { productType, discount } = isDiscountedProduct(singleProductData?.discount, singleProductData?.cashback_amount);
    return (
        <Box
            sx={{
                borderRadius: 0,
                minWidth: {
                    lg: "230px",
                    xl: "230px",
                },
                maxWidth: {
                    lg: "230px",
                    xl: "230px",
                },
                minHeight: "220px",
                boxShadow: {
                    lg: 0,
                },
                transition: "transform 0.2s linear",
                "&: hover": {
                    transform: "scale(1.06)",
                },
            }}
        >
            <NavLink
                to={`/card-details/${singleProductData?.id}/${titleToUrl(singleProductData?.title)}`}
                style={{ textDecoration: "none" }}
            >
                <Card sx={{
                    background: "transparent",
                    boxShadow: 0,
                    position: "relative",
                    overflow: "hidden",
                    borderRadius: 4,
                }}>
                    <CardMedia
                        component="img"
                        image={
                            singleProductData?.image
                                ? singleProductData?.image
                                : defaultProductImage
                        }
                        alt={singleProductData?.title}
                        sx={{
                            borderRadius: 4,
                            objectFit: "cover",
                            position: "relative",
                            height: { lg: "150px" },
                            width: { lg: "100%" },
                            boxShadow: { lg: 2 },
                            "&: hover": {
                                boxShadow: { lg: 6 },
                            },
                        }}
                        loading="lazy"
                    />
                    <Box
                        sx={{
                            position: "absolute",
                            top: { lg: "150px" },
                            right: "50%",
                            transform: "translate(50%, -50%)",
                            background: `transparent url(${discountImg}) center center/auto no-repeat`,
                            py: "3px",
                            textAlign: "center",
                        }}
                    >
                        <Typography
                            variant="subtitle1"
                            component="div"
                            sx={{
                                color: "#fff",
                                fontWeight: 400,
                                fontSize: 12,
                                px: "2px",
                                width: "180px",
                            }}
                        >
                            {`${productType}`} :
                            <Typography
                                variant="subtitle1"
                                component="span"
                                sx={{
                                    color: "white.main",
                                    fontWeight: 400,
                                    fontSize: 12,
                                    ml: "3px"
                                }}
                            >
                                {`${discount}%`}
                            </Typography>
                        </Typography>
                    </Box>
                    <CardContent
                        sx={{
                            mt: 1,
                            pb: "0 !important",
                            width: "100%",
                        }}>
                        <Tooltip title={singleProductData?.title}>
                            <Typography
                                variant="h4"
                                sx={{
                                    color: "textPrimary.main",
                                    fontWeight: { lg: 400 },
                                    fontSize: { lg: "13.6px" },
                                    display: "-webkit-box",
                                    WebkitLineClamp: 2,
                                    WebkitBoxOrient: "vertical",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    wordWrap: "break-word",
                                    wordBreak: "break-word",
                                    textAlign: "center",
                                    "&: hover": {
                                        fontWeight: { lg: 500 },
                                    },
                                }}
                            >
                                {singleProductData?.title}
                            </Typography>
                        </Tooltip>
                    </CardContent>
                </Card>
            </NavLink >
        </Box >
    );
};
export default AllGiftCard;
